module.exports = __webpack_public_path__ + "img/Monte_Kope_17.0506ec40.jpg";